// extracted by mini-css-extract-plugin
export default {"container":"kmL323","title-container":"OWG_vW","title":"p8SRBf","input":"uio6cW","button-container":"eW1kJ6","key-value-list":"_w6t2F","banner-container":"vzk5UL"};